<template>
  <div>
    <!-- treatment details card -->
    <div class="shadow-card2" v-if="!loading && treatment">
      <a-button
        :style="{
          border: 'none !important',
          'box-shadow': 'none !important',
        }"
        class="py-1 pl-3 pr-4 d-flex align-items-center"
        @click="$router.go(-1)"
      >
        <!-- <h4 class="mr-2 m-auto pb-1">
        <a-icon
            class="svg-icon-size treatment-bck-btn"
            type="arrow-left"
            :size="'small'"
            :style="{ color: getPrimaryColor() }"
          />
        </h4> -->
        <font-awesome-icon class="m-auto mr-2" :style="{ color: getPrimaryColor() }" :icon="['far', 'arrow-left']" />
        <h6 :style="{ color: getPrimaryColor() }" class="my-auto ml-2">Back</h6>
      </a-button>

      <div class="p-3 treatment-info">
        <p class="title gray900">{{ treatment.display_name }}</p>
        <p
          class="treatment-type"
          :style="{
            background: getPrimary50Color(),
            color: getPrimaryColor(),
          }"
        >
          {{
            treatment.treatment_type
              ? treatment.treatment_type.toLowerCase() === "others"
                ? "Medication"
                : treatment.treatment_type.toLowerCase() === "nutrition"
                ? "Nutrition & Diet"
                : treatment.treatment_type
              : $route.params.type && $route.params.type.toLowerCase() === "nonmedicaltreatments" && "Complimentary Therapy"
          }}
        </p>
        <hr />
        <!-- <img
          v-if="treatment.image_url.length"
          :src="treatment.image_url[0]"
          style=""
          alt=""
          class="treatment-image"
        /> -->

        <img v-if="treatment.url" :src="treatment.resized_images ? treatment.resized_images.dov1280x720 : treatment.url" class="treatment-image" alt="image" />

        <!-- <p v-if="treatment.category" class="description">
            <b>Treatment Category:</b> {{ treatment.category }}
          </p>
          <p v-if="treatment.value" class="description">
            <b>Treatment Value:</b> {{ treatment.value }}
          </p> -->

        <template v-if="treatment.treatment_type === 'others'">
          <p v-if="treatment.propritary_name" class="description"><b>Brand Name of Medication:</b> {{ treatment.propritary_name }}</p>

          <div v-if="treatment.nonpropritary_name" class="description">
            <b> Medication (Non Proprietary Name): </b>
            {{ treatment.nonpropritary_name[0] }}
          </div>

          <!-- <div> -->
          <p v-if="treatment.dosageform" class="description">
            <b>Medication Form:</b>
            <span v-for="(dosage, index) in treatment.dosageform" :key="index"> {{ dosage }}{{ index + 1 !== treatment.dosageform.length ? ", " : "" }} </span>
          </p>

          <p v-if="treatment.route_name" class="description">
            <b>Route of Administration: </b>
            <span v-for="(name, index) in treatment.route_name" :key="name"> {{ name }}{{ index + 1 !== treatment.route_name.length ? ", " : "" }} </span>
            <!-- {{ treatment.route_name }} -->
          </p>

          <p v-if="treatment.substance_name" class="description">
            <b>Active Ingredient:</b>
            <span v-for="(name, index) in treatment.substance_name" :key="index"> {{ name }}{{ index + 1 !== treatment.substance_name.length ? ", " : "" }} </span>
            <span v-for="(name, index) in treatment.active_numerator_strength" :key="index"> {{ name }}{{ index + 1 !== treatment.active_numerator_strength.length ? ", " : "" }} </span>
            <span v-for="(name, index) in treatment.active_ingred_unit" :key="index"> {{ name }}{{ index + 1 !== treatment.active_ingred_unit.length ? ", " : "" }} </span>
          </p>

          <p v-if="treatment.labeler_name" class="description">
            <b>Manufacturer:</b>
            <span v-for="(name, index) in treatment.labeler_name" :key="index"> {{ name }}{{ index + 1 !== treatment.labeler_name.length ? ", " : "" }} </span>
          </p>

          <!-- <p v-if="treatment.application_number" class="description">
              <b>Application Number:</b>
              <span
                v-for="(number, index) in treatment.application_number"
                :key="index"
                >{{ number }},</span
              >
            </p> -->

          <!-- <p v-if="treatment.category" class="description">
              <b>Category:</b>
              <span v-for="(cat, index) in treatment.category" :key="index"
                >{{ cat }},</span
              >
            </p> -->

          <p v-if="treatment.pharm_classes" class="description"><b>Pharmaceutical Class:</b> {{ treatment.pharm_classes }}</p>

          <p v-if="treatment.code" class="description">
            <b>NDC Link: </b>
            <span v-for="(code, index) in treatment.code" :key="code">{{ code }}{{ index + 1 !== treatment.code.length ? ", " : "" }} </span>
            <!-- {{ treatment.code }} -->
          </p>
        </template>

        <template v-else>
          <p class="mb-4 fw700 font16 gray800" v-if="treatment.treatment_type === 'Procedure'">
            Procedure Type:
            <span
              v-for="sType in treatment.sub_type"
              :key="sType"
              :style="{
                color: getPrimaryColor(),
                background: getPrimary50Color(),
              }"
              class="fw700 font12 rounded ml-2 py-1 px-2"
            >
              {{ sType }}
            </span>
          </p>
          <!-- <p v-if="treatment.description" class="description">
            <b>Description:</b> {{ treatment.description }}
          </p>
          <p v-if="treatment.resource" class="description">
            <b>Resource:</b> {{ treatment.description }}
          </p> -->
          <span v-if="treatment.description" class="description">
            <b class="pr-1">Description:</b>
            <span class="pl-1 des-html" v-html="treatment.description"></span>
            <template v-if="treatment.resource_url">
              <!-- <br /> -->
              <!-- <br /> -->
              <b class="pr-1" :style="{ display: 'inline-block' }">Helpful Resource:</b>
              <a :href="treatment.resource_url" target="_blank" class="cp" :style="{ color: getPrimaryColor() }">{{ treatment.resource_url }}</a>
            </template>
          </span>
          <!-- </div> -->
        </template>
      </div>

      <div class="treatment-question">
        <p class="gray700 fw700">Ask about {{ treatment.display_name }}</p>
        <!-- @click="() => $refs.treatmentQuestionModal.show(treatment.id, true)" -->
        <button
          @click="() => $refs.CreateNewPostModal.show('add', null, 'question', [], treatment.id)"
          :style="{
            background: getPrimaryColor(),
            color: 'white !important',
            border: 'none !important',
            'min-width': '146px',
          }"
          class="primary-button ml-4 q-btn"
        >
          Ask A Question
        </button>
      </div>

      <!-- <TreatmentQuestionModal ref="treatmentQuestionModal" /> -->
      <!-- <EditQuestion ref="treatmentQuestionModal" :userName="this.authUser.user.display_name" /> -->
      <CreateNewPostModal ref="CreateNewPostModal" :getPost="() => true" :questionType="'Treatment'" />
    </div>

    <div v-else-if="loading" class="d-flex justify-content-center my-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>

    <div v-else>Treatment not found in database</div>

    <!-- reviews section -->
    <template v-if="treatment && treatment.treatment_type === 'others'">
      <reviews :treatment="treatment" :getTreatmentDetails="getTreatmentDetails" />
    </template>

    <!-- recommendations section -->
    <template v-else-if="treatment">
      <recommendations :treatment="treatment" />
    </template>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import EditQuestion from "../../Modals/activity/EditQuestion.vue"
import CreateNewPostModal from "../../Modals/CreateNewPost.vue"
import Recommendations from "./Recommendations.vue"
import Reviews from "./Reviews.vue"

const AppRepository = RepositoryFactory.get("app")

export default {
  name: "Treatment",

  data() {
    return {
      treatment: null,
      loading: false,
    }
  },

  components: {
    Recommendations,
    Reviews,
    EditQuestion,
    CreateNewPostModal,
  },

  methods: {
    getTreatmentDetails() {
      this.loading = true
      if (this.$route.params.type === "others") {
        // searching for MEDICATION
        AppRepository.getOtherTreatment(this.$route.params.id, this.currentCircle.id)
          .then(res => {
            this.treatment = res.data.data.data[0]
            this.loading = false
          })
          .catch(err => {
            this.loading = false
          })
      } else if (this.$route.params.type === "nonmedicaltreatments") {
        // searching for CT
        AppRepository.searchNonmedicaltreatments(null, this.currentCircle.id, this.$route.params.id)
          .then(res => {
            this.loading = false
            this.treatment = res.data.data[0]
          })
          .catch(err => {
            this.loading = false
          })
      } else {
        // searching for ACTIVITY & PROCEDURE & NUTRITION
        AppRepository.getTreatment(this.$route.params.id, this.currentCircle.id)
          .then(res => {
            this.loading = false
            this.treatment = res.data.data.data[0]
          })
          .catch(err => {
            this.loading = false
          })
      }
    },
  },

  created() {
    this.getTreatmentDetails()
  },
}
</script>

<style lang="scss" scoped>
.starbg {
  background: #2a71d4;
  border-radius: 2px;
  padding: 3px;
  color: #fff;
}
.shadow-card2 {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  p {
    margin-bottom: 0;
  }
}
.treatment-question {
  background-color: #fff;
  text-align: center;
  padding: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-weight: 700;
  font-size: 16px;
  line-height: 42px;
  color: #33415f;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    gap: 24px;
  }

  .q-btn {
    border-radius: 6px;
    padding: 12px 24px;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
  }
}
.treatment-info {
  .title {
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 42px;
    // margin-top: 30px;
  }
  .treatment-type {
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 14px;
    border-radius: 4px;
    padding: 4px 8px;
    margin-top: 20px;
    // color: #2a71d4 !important;
  }
  .description {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 25px;
    margin-bottom: 0;
    // color: #1e2945 !important;

    @media screen and (max-width: 600px) {
      // display: flex;
      // flex-direction: column;
    }

    span {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      // color: #1e2945 !important;

      // p#isPasted,
      // p {
      // color: #1e2945 !important;
      // }
      // p {
      //   color: unset !important
      // }
    }

    &:last-child {
      margin-bottom: 50px;
    }
  }
}
.treatment-image {
  // max-width: 100%;
  max-height: 381px;
  // background-size: contain;
  display: flex;
  margin: auto;
  margin-bottom: 24px;
  max-width: 100%;
}
@media screen and (max-width: 900px) {
  .treatment-bck-btn {
    font-size: 20px !important;
  }
  .ml-4 {
    margin-left: 0 !important;
  }
}
.des-html {
  white-space: break-spaces;
}
p,
span,
ol {
  margin-bottom: 0 !important;
}
.des-html * {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/treatments/Treatment.vue